// Cart tokens whose booking has gone through, shared by every tab in this
// browser. The cart token lives in sessionStorage, which a duplicated tab
// inherits — so a second tab can still be holding the token of a cart that
// another tab has already paid for. Any write it sends lands on the paid cart,
// and update-cart's location_clean() strips its booking_id, turning a finished
// booking back into an "abandoned" cart. localStorage is visible to all tabs,
// which is what lets the stale one find out.
const convertedCartsKey = "sjdConvertedCartTokens";

// Enough to cover several bookings from one browser; oldest dropped first.
const maxRemembered = 20;

const readConvertedCarts = (): string[] => {
  try {
    const raw = localStorage.getItem(convertedCartsKey);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed)
      ? parsed.filter((token): token is string => typeof token === "string")
      : [];
  } catch {
    return [];
  }
};

export const markCartConverted = (token: string | null | undefined) => {
  if (!token) return;
  try {
    const tokens = readConvertedCarts().filter((t) => t !== token);
    tokens.push(token);
    localStorage.setItem(
      convertedCartsKey,
      JSON.stringify(tokens.slice(-maxRemembered))
    );
  } catch {
    // Storage unavailable (private mode / quota). The hub's remarketing guard
    // still refuses a deal for this cart; this only saves the stray writes.
  }
};

export const isCartConverted = (token: string | null | undefined): boolean =>
  Boolean(token) && readConvertedCarts().includes(token as string);
